/* eslint-disable no-param-reassign */
/* eslint-disable no-new */
/* eslint-disable no-undef */

function isIE() {
  const ua = window.navigator.userAgent; // Check the userAgent property of the window.navigator object
  const msie = ua.indexOf('MSIE '); // IE 10 or older
  const trident = ua.indexOf('Trident/'); // IE 11

  return (msie > 0 || trident > 0);
}

function setVarHeight() {
  if (!isIE()) {
    document.documentElement.style.setProperty('--window-height', `${window.innerHeight}px`);
  }
}

function scrollToMenu(el) {
  const target = document.querySelector(el);
  const to = target.getBoundingClientRect().top + window.scrollY;

  window.scroll({
    top: to,
    behavior: 'smooth',
  });
}

function handleCookies() {
  const cookieStatus = Cookies.get('confirmCookies');
  const btnAccept = document.querySelector('.btn--accept-cookies');

  if (cookieStatus === undefined || cookieStatus === null) {
    Cookies.set('confirmCookies', 'false');
    document.body.classList.add('show-cookie-bar');
  }

  if (cookieStatus === 'false') {
    document.body.classList.add('show-cookie-bar');
  }

  btnAccept.addEventListener('click', () => {
    Cookies.set('confirmCookies', 'true');
    document.body.classList.remove('show-cookie-bar');
  });
}

function toggleMenu() {
  const menu = document.querySelector('.menu-mobile');
  document.body.classList.toggle('menu-open');

  setVarHeight();

  if (document.body.classList.contains('menu-open')) {
    bodyScrollLock.disableBodyScroll(menu);
  } else {
    bodyScrollLock.enableBodyScroll(menu);
  }
}

function triggerToggleMenu() {
  const btns = [...document.querySelectorAll('[data-toggle="menu"')];

  btns.forEach((btn) => {
    btn.addEventListener('click', () => {
      toggleMenu();
    });
  });
}

function onMenuClick() {
  const linksMobile = [...document.querySelectorAll('.menu-mobile__list a')];
  const linksAside = [...document.querySelectorAll('.aside--left__menu a')];

  linksMobile.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const target = link.getAttribute('href');

      toggleMenu();
      scrollToMenu(target);
    });
  });

  linksAside.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const target = link.getAttribute('href');

      scrollToMenu(target);
    });
  });
}

function isElementInViewport(el) {
  const offset = 120;
  const windowPos = (window.scrollY + offset);

  if (windowPos >= el.offsetTop && (windowPos) < el.offsetTop + el.offsetHeight - offset) {
    return true;
  }

  return false;
}

function onScrollToggle() {
  const sections = [...document.querySelectorAll('[data-anchor]')];
  const minWidth = 768;

  window.addEventListener('scroll', () => {
    if (window.innerWidth >= minWidth) {
      sections.forEach((section) => {
        const isVisible = isElementInViewport(section);
        const { id } = section;

        if (isVisible) {
          document.querySelector(`.aside--left__menu a[href="#${id}"]`).classList.add('active');
        } else {
          document.querySelector(`.aside--left__menu a[href="#${id}"]`).classList.remove('active');
        }
      });
    }
  });
}

function stickyBurger() {
  const isMobile = window.innerWidth < 1240;
  const container = document.querySelector('.container-menu');
  const burger = container.querySelector('.btn-menu');

  window.addEventListener('scroll', () => {
    if (isMobile && container.getBoundingClientRect().top <= 0) {
      burger.classList.add('sticky');
    } else {
      burger.classList.remove('sticky');
    }
  });
}

function initSwiper() {
  // eslint-disable-next-line no-unused-vars
  const mySwiper = new Swiper('.swiper-container', {
    // Optional parameters
    spaceBetween: 120,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('#c--intro')) {
    new CanvasMouse('#c--intro');
    new CanvasScroll('#c--scroll-1', 1);
    new CanvasScroll('#c--scroll-2', 2);
    new CanvasScroll('#c--scroll-3', 3);
  }

  new LazyLoad({
    elements_selector: '[data-src], [data-bg]',
  });

  document.querySelector('.btn--toggle-grid').addEventListener('click', () => {
    document.body.classList.toggle('grid-enabled');
  });

  window.addEventListener('resize', () => {
    setVarHeight();
  });

  if (document.querySelector('#c--intro')) {
    onScrollToggle();
    triggerToggleMenu();
    onMenuClick();
    stickyBurger();
    initSwiper();
  }
  handleCookies();
});